import { TrendingWidgetPositioner } from 'components/widget/trending-widget/trending-widget-positioner'
export default TrendingWidgetPositioner
